const URL_PATTERN = /\b(?:https?|ftp):\/\/\S+|\bwww\.[a-z0-9-]+\.\S+|\b[a-z0-9][a-z0-9-]*\.(?:com|net|org|edu|gov|io|co|us|uk|ca|info|biz|app|dev|me|tv|xyz|tech|online|store|site)(?:\/\S*)?\b/i

export const sanitizeSettlementMessage = (value) => (value ?? '').replace(/[^\x20-\x7E]/g, '')

export const containsUrl = (value) => URL_PATTERN.test(value ?? '')
